import moment from "moment";

export const DateTimeDisplay = ({ date, format }) => {
  const dateObject = moment.utc(date).local();

  if (!dateObject.isValid()) {
    return <div>-</div>;
  }

  return <div>{dateObject.format(format)}</div>;
};
